import api from '..'

const DownloadDisabledUsers = (allSelected = false, courseIds: any[], q: any) => {
  return api.post('administration/courses/download_disabled_users', {
    courseIds: allSelected ? [] : courseIds,
    excludeCourseIds: allSelected ? courseIds : [],
    selectAll: allSelected,
    q,
  })
}

export default DownloadDisabledUsers

